
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSleetShowersPolartwilight as ObiLightningLightSleetShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-sleet-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningLightSleetShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-light-sleet-showers-polartwilight',
   elementClass: ObiLightningLightSleetShowersPolartwilightElement,
   events: {
     
   }
  });
 
 